export default "__VITE_ASSET__d92536e2__"